<div class="page-header">
  <ng-content></ng-content>
  <div class="buttons-header">
    <ng-content select="[buttons]"></ng-content>
  </div>
</div>